import { useNavigate } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { RoundIconButton } from '@/design-system-v2/round-icon-button';
import { userStore } from '@/stores/user.store';

export const MeetingDebugButton = observer(
  ({ meetingId }: { meetingId: string }) => {
    const navigate = useNavigate();

    if (!userStore.isInternalUser) return null;

    return (
      <RoundIconButton
        size="sm"
        icon={Icons.debug}
        label="Debug"
        onClick={() =>
          navigate({ to: '/meeting-debug', search: { meetingId } })
        }
      />
    );
  }
);
